import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ProductCard from '../components/ProductCard';
import './ProductCategory.css';

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const ProductCategory = () => {
    const { slug } = useParams();
    const [products, setProducts] = useState([]);
    const [category, setCategory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCategoryAndProducts = async () => {
            try {
                if (!slug) throw new Error('Slug no proporcionado');

                const categoryResponse = await axios.get(`${apiUrl}/api/categories/${slug}`);
                
                if (!categoryResponse.data) {
                    throw new Error('Categoría no encontrada');
                }

                setCategory(categoryResponse.data);

                // Intentar obtener los productos de la categoría y manejar el 404
                try {
                    const productsResponse = await axios.get(`${apiUrl}/api/products/category/${categoryResponse.data.slug}`);
                    
                    if (productsResponse.data.length === 0) {
                        setProducts([]); // No hay productos en esta categoría
                    } else {
                        setProducts(productsResponse.data);
                    }
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        console.warn('No se encontraron productos en esta categoría.');
                        setProducts([]); // Manejar el caso de productos vacíos
                    } else {
                        throw error; // Lanza otros errores para manejarlos en el catch general
                    }
                }
            } catch (error) {
                console.error('Error al obtener la categoría y productos:', error);
                setError('Error al cargar los productos de esta categoría. Por favor, intenta de nuevo más tarde.');
            } finally {
                setLoading(false);
            }
        };

        fetchCategoryAndProducts();
    }, [slug]);

    if (loading) return <p>Cargando categoría...</p>;

    return (
        <div className="product-category-container">
            {error ? (
                <div className="error-message">
                    <h2 className="no-products-title">Categoría no encontrada</h2>
                    <p className="no-products-message">{error}</p>
                </div>
            ) : (
                <>
                    <h1 className="category-title">Productos en la categoría: {category?.name}</h1>
                    <div className="product-list">
                        {products.length > 0 ? (
                            products.map(product => (
                                <ProductCard key={product._id} product={product} />
                            ))
                        ) : (
                            <p className="no-products-message">No hay productos en esta categoría.</p>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default ProductCategory;
